import { useQuery } from '@apollo/client/react';

import { CardDocument } from './query.graphql';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useCard(
  cardId: string | undefined,
  { includeHiddenFieldAttachments = false }: { includeHiddenFieldAttachments?: boolean } = {},
) {
  return useQuery(CardDocument, {
    variables: {
      cardId: cardId ?? '',
      includeHiddenFieldAttachments,
    },
    // this will stop query from firing when cardId is an empty string,
    // which can be done on first render when getting cardId from the Router object
    skip: !cardId,
    fetchPolicy: 'cache-and-network',
    initialFetchPolicy: 'network-only',
  });
}
